import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var MessageOutlineSVG = function MessageOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27 4H5a3 3 0 00-3 3v12a3 3 0 003 3h3v6a1 1 0 000 .4 1 1 0 00.6.5 1 1 0 00.8 0 1 1 0 00.3-.2l6.7-6.7H27a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H16a1 1 0 00-.7.3L10 25.6V22a2 2 0 00-2-2H5a1 1 0 01-1-1V7a1 1 0 011-1h22a1 1 0 011 1z"
  }));
};
MessageOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MessageOutlineSVG);